<template>
    <div class="spot-badge spot-badge-draggable-trigger">
        <div class="image"
             @click="redirectTo(`/${spot.city.slug}/${spot.slug}`)"
             :style="{ backgroundImage: `url(${spot.feature_image_lg})` }">

            <svg v-if="spot.category_id == 1"><use xlink:href="#eat-icon-full"></use></svg>
            <svg v-if="spot.category_id == 2"><use xlink:href="#sleep-icon-full"></use></svg>
            <svg v-if="spot.category_id == 3"><use xlink:href="#play-icon-full"></use></svg>
        </div>
        <div class="info">
            <a :href="`/${spot.city.slug}/${spot.slug}`" class="ignore-elements">
                <h3 v-text="spot.title"></h3>
            </a>
            <div class="details" v-if="spot.subcategory && spot.neighborhood">
                <span v-text="spot.subcategory.title"></span> in <span v-text="spot.neighborhood.title"></span>
            </div>
            <EditCaption class="ignore-elements" :list="list" :spot="spot"></EditCaption>
        </div>
        <div class="actions" v-if="ownsList">
            <SpotDropdown class="ignore-elements"
                          :index="index"
                          :list="list"
                          :schedule="schedule"
                          :current-tab="currentTab">
            </SpotDropdown>

            <Tooltip v-if="index == 0 && currentTab == 'unscheduled'" :tooltips="tooltips" name="calendar-btn"></Tooltip>

            <button type="button" @click="openAddSpotDatesModal()" class="ignore-elements">
                <svg class="add_date_black"><use xlink:href="#add_date_black"></use></svg>
            </button>
        </div>
    </div>
</template>
<script>


import Tooltip from '@/components/Tooltip'
import Helpers from '@/mixins/Helpers'
import EditCaption from './EditCaption'
import SpotDropdown from '@/components/ListsSchedules/SpotDropdown'

export default {

    mixins:[Helpers],

    props:['index', 'list', 'schedule', 'currentTab', 'tooltips'],

    components:{
        Tooltip,
        EditCaption,
        SpotDropdown,
    },

    data(){
        return {
            spot: this.schedule.spot
        }
    },

    methods: {
        openAddSpotDatesModal() {
            eventBus.$emit('open-add-to-schedule-modal', {
                spot: this.spot,
                tab: this.currentTab
            })
        },
    },

    computed:{
        ownsList() {
            return window.config.isLoggedIn && window.config.user.id == this.list.user_id;
        },
    }
}
</script>
